import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Instagram, RefreshCw, Eye, Loader2, Check } from 'lucide-react';

const InstagramPanel = ({ shortcodes, setShortcodes, onSave, onReload, saving }) => {
  const updateOne = (idx, value) => {
    const m = value.match(/instagram\.com\/(?:p|reel|tv)\/([A-Za-z0-9_-]+)/);
    const clean = m ? m[1] : value.trim();
    const next = [...shortcodes];
    next[idx] = clean;
    setShortcodes(next);
  };

  return (
    <div className="space-y-4">
      <div className="p-4 rounded-lg border border-gray-800" style={{ backgroundColor: 'var(--tp-dark)' }}>
        <div className="flex items-start justify-between gap-3 mb-3 flex-wrap">
          <div>
            <h3 className="text-white font-bold flex items-center gap-2" style={{ fontFamily: 'Oswald, sans-serif' }}>
              <Instagram size={18} className="text-pink-500" /> 4 POST IN HOME
            </h3>
            <p className="text-gray-500 text-xs mt-1">
              Incolla il link del post (o solo lo shortcode). Supporta /p/, /reel/, /tv/.
            </p>
          </div>
          <Button onClick={onReload} size="sm" variant="outline" className="border-gray-700 text-white hover:bg-gray-800">
            <RefreshCw size={14} />
          </Button>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {[0, 1, 2, 3].map(i => (
            <div key={i} className="space-y-2">
              <label className="block text-gray-400 text-xs tracking-wider" style={{ fontFamily: 'Oswald, sans-serif' }}>
                POST #{i + 1}
              </label>
              <Input
                data-testid={`ig-input-${i}`}
                value={shortcodes[i] || ''}
                onChange={e => updateOne(i, e.target.value)}
                placeholder="https://www.instagram.com/p/XXXXXX/"
                className="bg-gray-900 border-gray-700 text-white font-mono text-xs"
              />
              {shortcodes[i] && (
                <a
                  href={`https://www.instagram.com/p/${shortcodes[i]}/`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-xs text-pink-400 hover:text-pink-300 inline-flex items-center gap-1"
                >
                  <Eye size={12} /> Anteprima: {shortcodes[i]}
                </a>
              )}
            </div>
          ))}
        </div>

        <div className="mt-6 flex gap-2 flex-wrap">
          <Button
            onClick={onSave}
            disabled={saving}
            data-testid="ig-save-btn"
            className="bg-pink-600 hover:bg-pink-700 text-white font-bold"
          >
            {saving ? <Loader2 size={14} className="mr-2 animate-spin" /> : <Check size={14} className="mr-2" />}
            SALVA IN HOME
          </Button>
          <a
            href="https://www.instagram.com/tecnicheperfette/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-4 py-2 rounded bg-gray-800 hover:bg-gray-700 text-white border border-gray-700 text-sm"
          >
            <Instagram size={14} /> Apri profilo IG
          </a>
        </div>
      </div>

      <div className="p-4 rounded-lg border border-gray-800" style={{ backgroundColor: 'var(--tp-dark)' }}>
        <p className="text-gray-400 text-xs uppercase tracking-wider mb-3" style={{ fontFamily: 'Oswald, sans-serif' }}>
          ANTEPRIMA HOME
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {shortcodes.filter(Boolean).slice(0, 4).map((code, idx) => (
            <div key={code + idx} className="rounded-lg overflow-hidden border border-gray-700 bg-white" style={{ aspectRatio: '1 / 1.15' }}>
              <iframe
                src={`https://www.instagram.com/p/${code}/embed/`}
                title={`preview-${code}`}
                loading="lazy"
                scrolling="no"
                frameBorder="0"
                className="w-full h-full"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default InstagramPanel;
